<template>
  <div class="row">
    <div class="col-md-12">
      <fieldset :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form
              action
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              v-on:submit.prevent="save()"
            >
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="project_code" class="form-control-label" v-required>Project Code</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="project_code"
                    name="project_code"
                    placeholder
                    class="form-control"
                    v-model="input.project_code"
                    ref="project_code"
                    readonly
                    disabled
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="customer_name" class="form-control-label" v-required>Customer Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="customer_name"
                    name="customer_name"
                    placeholder
                    class="form-control"
                    v-model="input.customer_name"
                    ref="customer_name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="remarks" class="form-control-label">Project Description</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="remarks"
                    id="remarks"
                    rows="9"
                    placeholder
                    class="form-control"
                    v-model="input.remarks"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
      <div class="card-footer"></div>
    </div>
  </div>
</template>
<script>

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import ProjectModel from './model/Project'

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'Project',
        sectionName: 'project',
        sectionIcon: 'fab fa-buffer',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.project,
        navigation: [
          { name: 'Project', route: 'project.index' },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {
          buttons: [
            { name: 'Vendor Project', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'vendorproject.index' }) } },
            { name: 'Project', icon: 'fab fa-buffer', action: () => { this.$router.push({ name: 'project.index' }) } },
          ]
        }
      },
      input: ProjectModel(),
      requiredInput: [
        {key: 'customer_name', title: 'Customer Name'},
      ],
      modelID: this.$route.params.id ? this.$route.params.id : null,
      processing: false,
    }
  },
  props: {
    pageType: String
  },
  computed: {
    isDisabled() {
      return this.processing
    },
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation
  }
}
</script>